import { check2fa } from "../../services/Api/loginService";
import { useTokenContext } from "../../context/tokenContext";
import { useConnexionStore } from "../../stores/Layout/connexion";
import { showToastError } from "../../services/Toasts/toasts";
import { ToastContainer } from "react-toastify";
import { redirection } from "../../services/Utils/functionService";
import { useNavigate } from "react-router-dom";
import AuthCode from "react-auth-code-input";

const Modal2fa = () => {
  const {
    code2fa,
    setCode2fa,
    email,
    showModal2fa,
    setShowModal2fa,
    validate2WeeksWithout2fa,
    setValidate2WeeksWithout2fa,
  } = useConnexionStore();
  //Context
  const { refreshUserData } = useTokenContext();
  const navigate = useNavigate();

  const handleCheck2fa = async (e: any) => {
    e.preventDefault();
    try {
      const data = await check2fa(code2fa, email, validate2WeeksWithout2fa);
      setShowModal2fa(false);
      await refreshUserData();
      redirection(location, navigate, data?.isSuperAdmin);
    } catch (err) {
      showToastError("Code 2FA incorrect");
    }
  };

  if (!showModal2fa) return null;

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-hidden focus:outline-hidden">
        <ToastContainer position="top-center" />
        <div className="relative w-auto md:w-1/4 my-6 mx-auto max-w-3xl min-w-[85%]">
          {/* Content */}
          <div className="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white outline-hidden focus:outline-hidden">
            {/* Header */}
            <div className="w-full bg-white p-3 rounded-t-xl">
              <h4 className="text-xl font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <svg className="w-5 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                Sécurité
              </h4>
            </div>
            
            {/* Body */}
            <div className="w-full flex flex-col items-center justify-center text-grey-trio">
              <div className="flex flex-col justify-center items-center w-11/12 mb-6">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-700 mb-2 text-center">
                  Authentification à deux facteurs
                </h3>
                <p className="text-md text-gray-600 text-center mb-4">
                  Veuillez saisir le code à 6 chiffres pour vous connecter.
                </p>
                
                {/* MFA Code Input */}
                <div className="w-full space-y-2">
                  <label className="text-sm font-medium text-gray-700 block text-center w-full mb-3">
                    Code de vérification
                  </label>
                  <div className="flex justify-center">
                    <AuthCode
                      allowedCharacters="numeric"
                      length={6}
                      onChange={(value) => setCode2fa(value)}
                      containerClassName="flex gap-2"
                      inputClassName="w-12 h-12 border-2 border-gray-200 rounded-xl text-center text-lg font-semibold focus:border-yellow-trio focus:outline-none transition-all duration-300 shadow-sm hover:shadow-md"
                    />
                  </div>
                </div>
                
                {/* Remember me checkbox */}
                <div className="w-full mt-4 p-3 rounded-lg bg-gray-50 border border-gray-200">
                  <div className="flex items-center justify-center gap-3">
                    <input
                      type="checkbox"
                      name="rememberme"
                      id="rememberme"
                      className="w-4 h-4 text-yellow-trio bg-gray-100 border-gray-300 rounded focus:ring-yellow-trio focus:ring-2"
                      checked={validate2WeeksWithout2fa}
                      onChange={(e) =>
                        setValidate2WeeksWithout2fa(e.target.checked)
                      }
                    />
                    <label htmlFor="rememberme" className="text-sm font-medium text-gray-700">
                      Se souvenir de moi
                    </label>
                  </div>
                  <p className="text-xs text-gray-500 text-center mt-1 italic">
                    Pour les 14 prochains jours
                  </p>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end p-3 rounded-b-2xl bg-white gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-500 hover:bg-red-500 hover:text-white cursor-pointer font-semibold rounded-xl transition-all duration-200 flex items-center gap-2 text-sm"
                type="button"
                onClick={() => setShowModal2fa(false)}
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                Annuler
              </button>
              <button
                className="px-4 py-2 bg-yellow-trio hover:bg-yellow-400 cursor-pointer text-gray-700 font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-2 text-sm"
                type="button"
                onClick={(e) => {
                  handleCheck2fa(e);
                }}
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Valider
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-45 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default Modal2fa;
